const tripsMenu = {
  sender: [
    {
      title: 'Request Delivery',
      description: 'Create & send delivery request',
    },
    {
      title: 'Incoming Requests',
      description: 'See travelers interested in your requests',
    },
    {
      title: 'My Requests',
      description: 'View all your sender requests',
    },
  ],
  traveler: [
    {
      title: 'List New Trip',
      description: 'Monetize your travel',
    },
    {
      title: 'My Listings',
      description: 'Manage your trips',
    },
    {
      title: 'My Requests',
      description: 'View carrying requests',
    },
  ],
};

export default tripsMenu;

